module.exports = __webpack_public_path__ + "static/media/04.63f7cce4.jpg";